import { EditableMarkdownComponent } from "components/Form/components/EditableMarkdown/EditableMarkdown";
import { FormComponentProps } from "components/Form/components/FormComponentProps";
import { Input } from "components/Form/components/Input/Input";

export const EditableMarkdownFormComponent = ({
    input,
    meta,
    fieldProps,
    fieldAttr,
}: FormComponentProps) => {
    return (
        <Input fieldProps={fieldProps} fieldAttr={fieldAttr} input={input} meta={meta}>
            <EditableMarkdownComponent
                identifier={input.name}
                inputProps={input}
                attributes={fieldAttr}
                className={fieldProps?.className}
                isReadOnly={fieldAttr?.disabled}
                isCollapsible={fieldProps?.isCollapsible}
                hugWhenEmpty={fieldProps?.hugWhenEmpty}
                editOnClick={fieldProps?.editOnClick}
            />
        </Input>
    );
};
